import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const tl1 = gsap.timeline();
tl1.to(".homepage-bubble", { opacity: 1 }, 2);
tl1.to(".homepage-button", { delay: 1, opacity: 1 });

const homepageButton = document.querySelector(".homepage-button");

// const tl2 = gsap.timeline({ paused: true });
// tl2.to(".title-marjane-eyeopen", { opacity: 1, y: 1 });
// tl2.to(".title-marjane-eyeclosed", { y: 1 }, "0");

// if (homepageButton !== null) {
//   homepageButton.addEventListener("click", () => {
//     tl2.play();
//   });
// }

const tl3 = gsap.timeline({
  scrollTrigger: {
    trigger: ".introduction",
    start: "top top",
    end: "+=3000",
    scrub: true,
    pin: true,
    // markers: true,
    anticipatePin: 1,
  },
});

tl3.to(".introduction-bubble", { delay: 2, opacity: 1 });
tl3.to(".introduction-choices", { delay: 4, opacity: 1 });

gsap.to(".religion-stories", {
  scrollTrigger: {
    trigger: ".religion-mask",
    start: "top top",
    end: "+=600%",
    pin: true,
    scrub: 2,
    // markers: true,
  },
  x: "-313%",
  ease: "sine.inOut",
});

gsap.to(".justice-stories", {
  scrollTrigger: {
    trigger: ".justice-mask",
    start: "top top",
    end: "+=600%",
    pin: true,
    scrub: 2,
    // markers: true,
  },
  x: "-490%",
  ease: "sine.inOut",
});

const buttonReligion = document.querySelector(".religion-2-button");
const religion2 = document.querySelector(".religion-2");
const religion2Clicked = document.querySelector(".religion-2-clicked");

if (buttonReligion !== null) {
  buttonReligion.addEventListener("click", () => {
    religion2.classList.toggle("is-hidden");
    religion2Clicked.classList.toggle("is-active");
  });
}

const buttonJustice = document.querySelector(".justice-1-button");
const justice1 = document.querySelector(".justice-1");
const justice1Clicked = document.querySelector(".justice-1-clicked");

if (buttonJustice !== null) {
  buttonJustice.addEventListener("click", () => {
    justice1.classList.toggle("is-hidden");
    justice1Clicked.classList.toggle("is-active");
  });
}

const buttonDetailsShow = document.querySelector(".buy-details-show");
const buttonDetailsHide = document.querySelector(".buy-details-hide");
const details = document.querySelector(".buy-details");

if (buttonDetailsShow !== null) {
  buttonDetailsShow.addEventListener("click", () => {
    details.classList.add("is-active");
    buttonDetailsHide.classList.add("is-active");
    buttonDetailsShow.classList.add("is-hidden");
    console.log("clicked");
  });
}

if (buttonDetailsHide !== null) {
  buttonDetailsHide.addEventListener("click", () => {
    details.classList.remove("is-active");
    buttonDetailsHide.classList.remove("is-active");
    buttonDetailsShow.classList.remove("is-hidden");
    console.log("clicked");
  });
}

gsap.to(".buy-footer-mask", {
  yPercent: 190,
  ease: "none",
  scrollTrigger: {
    trigger: ".buy-footer-container",
    start: "top 70%",
    end: "bottom 80%",
    scrub: 0.5,
  },
});
